import Logo from '@/components/Logo'
import type { RadioSettings } from '@/types/radio'
import {MapPin} from 'lucide-react'

function SiteFooter({ settings }: { settings: RadioSettings | null }) {
  return (
    <footer className="border-t border-white/10 bg-[#06145a]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-6 md:flex-row lg:px-6">
        <Logo />
        <p className="font-script text-xl text-white/90">{settings?.slogan || 'A rádio da nossa gente!'}</p>
        <p className="flex items-center gap-2 text-sm text-white/70">
          <MapPin size={14} /> {settings?.address || 'Bonita FM 87,9 | São José do Seridó/RN'}
        </p>
      </div>
      <p className="pb-5 text-center text-[11px] text-white/50">
        © {new Date().getFullYear()} {settings?.stationName || 'Bonita FM'} {settings?.frequency || '87,9'} — Todos os direitos reservados.
      </p>
    </footer>
  )
}

export default SiteFooter
